var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      staticStyle: { "z-index": "600" },
      attrs: { "content-class": "dialogText", "max-width": "400", light: true },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c(
            "v-card",
            [
              _c(
                "div",
                {
                  staticClass: "absX",
                  on: {
                    "&click": function ($event) {
                      return _vm.closeDialog.apply(null, arguments)
                    },
                  },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "myGray", attrs: { "x-large": "" } },
                    [_vm._v("mdi-window-close")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "spacer-25" }),
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Teile die App mit deinen Freunden!"),
              ]),
              _c("div", { staticClass: "text-center" }, [
                _c("div", [
                  _c("div", {
                    staticClass: "qrCode",
                    domProps: { innerHTML: _vm.qrCodeData },
                  }),
                ]),
                _c("div", { staticClass: "url" }, [_vm._v(_vm._s(_vm.appUrl))]),
              ]),
              _c(
                "v-card-actions",
                { staticClass: "text-center justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "okBtn rounded100",
                      attrs: { large: "", text: "" },
                      on: { click: _vm.ok },
                    },
                    [_vm._v("OK")]
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "pb-3" }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }